<!-- Представление PDF для сохранения работоспособности старых ссылок с ?tab=pdf. -->
<template>
  <EdoDocumentPdfPreview
    v-bind="$props"
    @open-pdf="$emit('open-pdf')"
    @download-pdf="$emit('download-pdf')"
    @pdf-loaded="$emit('pdf-loaded')"
    @pdf-error="$emit('pdf-error', $event)"
    @refresh-pdf="$emit('refresh-pdf')"
  />
</template>

<script>
import EdoDocumentPdfPreview from "@/components/Edo/DocumentPdfPreview.vue";

export default {
  name: "EdoDocumentPdfTab",

  components: {
    EdoDocumentPdfPreview,
  },

  props: {
    document: { type: Object, required: true },
    visible: { type: Boolean, default: false },
    pdfPendingVisible: { type: Boolean, default: false },
    pdfPollingHint: { type: String, default: "" },
    isPdfLoading: { type: Boolean, default: false },
    pdfLoadError: { type: Boolean, default: false },
    pdfPreviewUrl: { type: String, default: "" },
  },

  emits: ["open-pdf", "download-pdf", "pdf-loaded", "pdf-error", "refresh-pdf"],
};
</script>
